import React from 'react';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-field-deep" data-id="element-145" data-mp="1o3dmwcdeadr5">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center sm:py-20" data-id="element-146" data-mp="2223lxxjryni5">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-[3px] border-willow bg-willow/10 text-cream" data-id="element-147" data-mp="1x41zr3r1y82g">
          <span className="font-display text-4xl font-black leading-none" data-id="element-148" data-mp="19co9d3cgomk4">7</span>
          <span className="font-display text-xs font-extrabold uppercase tracking-widest" data-id="element-149" data-mp="14h8tk5uw8gl2">Days</span>
        </div>
        <p className="mt-6 text-[11px] font-semibold uppercase tracking-[1.6px] text-willow" data-id="element-150" data-mp="1j6n61mtrne4o">Zero risk</p>
        <h2 id="guarantee-heading" className="mt-3 font-display text-3xl text-cream sm:text-5xl" data-id="element-151" data-mp="1ec0tvhfv1hjj">
          Run your next session from it.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-cream/80" data-id="element-152" data-mp="lo512ntew9s1">
          Open Volume 1, print Session 01 and run it with your squad. Try the
          Season Route Planner and the When the Session Goes Sideways cards. If
          No-Queue Cricket doesn&apos;t make your sessions easier to plan and
          run, email us within 7 days and you get every cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-153" data-mp="12r68yn5l8p9i">
          {chips.map(chip => <li key={chip} className="rounded-full border border-field-line px-4 py-2 text-[13px] text-cream/75" data-id="element-154" data-mp="61fgetguxc6c">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}